<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['common_focusTracker'] }} <span class="text-12-400 ri-ps-2 ri-pe-3">{{
            ss.getFormattedDate(dateString(), 'd MMM y, EEE') }}</span></h6>
    <div class="flex items-center gap-6">
        <span class="collab-icon-wrapper" (click)="addCollaborator()" role="button"
            *ngIf="isCollab()">
            <app-svg [name]="isCollab() ? 'users' : 'addUser'" [color]="ss.theme().color12"></app-svg>
            <span class="collab-badge" *ngIf="collabCount() > 0">{{ collabCount() }}</span>
        </span>
        <app-svg name="comment" (click)="openComments()" role="button" [color]="ss.theme().color12"></app-svg>
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            [color]="ss.theme().color12"></app-svg>
        <mat-menu #infoMenu="matMenu" yPosition="above" xPosition="before" class="me-menu info-menu">
            <button mat-menu-item (click)="openFeatureInfo()" *ngIf="role() === 'owner'">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="info" class="ri-pe-3"
                        [color]="ss.theme().color35"></app-svg>{{ ss.texts()['common_featureGuide'] }}</span>
            </button>
            <button mat-menu-item (click)="downloadImage()" *ngIf="relativeAttempts().length > 0">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="import" class="ri-pe-3"
                        [color]="ss.theme().color35"></app-svg>{{ ss.texts()['shareQrAndLink_download'] }}</span>
            </button>
            <button mat-menu-item (click)="addCollaborator()" class="common-menu-width" *ngIf="role() === 'owner'">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="users"
                        class="ri-me-3 flex items-center justify-center" [width]="'20px'" [height]="'20px'"
                        style="width: 24px; height: 24px;" [color]="ss.theme().color35"></app-svg>{{
                    ss.texts()['common_collaborate'] }}</span>
                @if(collabCount() !== 0){
                <div class="menu-collaborator-add">
                    <span class="color-35" [ngClass]="'collaborator-count'">{{collabCount()}}</span>
                </div>
                }@else{
                <app-svg name="collaboratorAdd" class="flex items-center justify-center"
                    style="width: 18px; height: 18px;"></app-svg>
                }
            </button>
            <button mat-menu-item (click)="removeCollab('left')" *ngIf="role() !== 'owner'">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="leave"
                        class="ri-me-3 flex items-center justify-center" [width]="'18px'" [height]="'18px'"
                        style="width: 24px; height: 24px;" [color]="ss.theme().color11"></app-svg>{{
                    ss.texts()['common_leave'] }}</span>
            </button>
            <button mat-menu-item (click)="removeCollab('blocked')" *ngIf="role() !== 'owner'">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="block" [color]="ss.theme().color11"
                        class="ri-me-3 flex items-center justify-center" [width]="'18px'" [height]="'18px'"
                        style="width: 24px; height: 24px;"></app-svg>{{
                    isOwnerBlocked() ? (ss.texts()['common_unblock']) : ss.texts()['common_block']
                    }}</span>
            </button>
        </mat-menu>
        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>
<div class="body-section ri-px-4">
    <div class="highest-attempt-block ri-py-6">

        <p class="text-18-400 color-8 mb-0 ri-pb-4 text-center">{{ ss.texts()['focus_highestScore'] }}</p>
        <p class="text-36-500 color-8 mb-0 ri-pb-4 text-center">{{ highestAttempt().score }}</p>
        <div class="attempt-info">
            <span class="text-12-400 mb-0"> {{ ss.texts()[highestAttempt().level === 1 ? 'common_level1' :
                highestAttempt().level === 2 ? 'common_level2' : 'common_level3'] }}</span>
            <span class="text-12-400 mb-0">{{ highestAttempt().duration | secondsToTime }}</span>
        </div>
    </div>
    <div class="attempt-block ri-mt-4 flex justify-between items-center ri-px-4 ri-py-2"
        *ngFor="let attempt of relativeAttempts(); let i = index;"
        [ngClass]="{'ri-mb-4': i === relativeAttempts().length - 1}">
        <div class="flex flex-col gap-2">
            <p class="text-16-400 color-8 flex items-center">
                <span> {{ ss.texts()[attempt.level === 1 ? 'common_level1' : attempt.level === 2 ? 'common_level2' :
                    'common_level3'] }}</span>
                <app-svg name="trophy" class="ri-ms-2" [color]="ss.theme().color35"
                    *ngIf="attempt.id === highestAttempt().id"></app-svg>
            </p>
            <div class="flex">
                <div class="inline-flex items-center ri-pe-3">
                    <span class="text-12-400 color-7">{{ (attempt.shapeCount * 6) |
                        timeFormat }}</span>
                </div>
                <div class="inline-flex items-center ri-pe-3">
                    <span class="text-12-400 color-7">{{ ss.getFormattedDate(attempt.startAt, 'h:mm a') }}</span>
                </div>
            </div>
        </div>
        <div class="flex items-center">
            <p class="text-16-500 color-8 mb-0 text-center">{{ attempt.shapeCount * attempt.level }}</p>
            <app-svg class="ri-ms-4" name="trash" [color]="ss.theme().color11" role="button"
                (click)="deleteAttempt(attempt)" *ngIf="role() === 'owner'"></app-svg>
        </div>
    </div>
    <div class="extra-block" *ngIf="todayDateString() === dateString()"></div>
</div>
<div class="add-button" *ngIf="role() === 'owner' && todayDateString() === dateString()">
    <button class="btn" (click)="openFocusLevelSelect()"><app-svg name="play"
            [color]="ss.theme().color12"></app-svg></button>
</div>
<div class="train-button" *ngIf="role() !== 'owner' && todayDateString() === dateString()">
    <button class="btn" (click)="openFocusLevelSelect()">{{ ss.texts()['focus_viewerActionScreenCtaContent'] }}</button>
</div>